import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.FLIGHTS_SEARCH_RESULT,
    name: "FlightSearchResult",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS.PERMISSIONS,
    },
    component: () =>
      import("@/modules/FlightSearchResult/views/FlightSearchResult.vue"),
  },
];

export default routes;
